import getClientConfig from "./getClientConfig";
import { FilingTypeEnum, FeatureFlagEnum } from "./enums";

const reportTypeMapping = () => {
    const { featureFlags } = getClientConfig();
    const ReturnTypeFFMapping = {};
    ReturnTypeFFMapping[FilingTypeEnum.OSSIMPORT] = featureFlags?.[FeatureFlagEnum.ENABLE_IOSS_CORRECTION];
    ReturnTypeFFMapping[FilingTypeEnum.OSSNONUNION] = featureFlags?.[FeatureFlagEnum.ENABLE_NON_UNION_OSS_GROUP_FILTER_OPEN_RETURNS];
    ReturnTypeFFMapping[FilingTypeEnum.OSSUNION] = featureFlags?.[FeatureFlagEnum.ENABLE_UNION_OSS_GROUP_FILTER_OPEN_RETURNS];
    ReturnTypeFFMapping[FilingTypeEnum.VATBOOKS] = featureFlags?.[FeatureFlagEnum.ENABLE_CORRECTION_FILTERS_VAT_BOOK];
    ReturnTypeFFMapping[FilingTypeEnum.ECLISTING] = featureFlags?.[FeatureFlagEnum.ENABLE_EC_TRANSACTION_FILTER_OPEN_RETURNS];
    return ReturnTypeFFMapping;
};

export const rescheduleAllowedForReturnType = (filingType, featureFlags) => {
    switch (filingType) {
        case FilingTypeEnum.OSSIMPORT:
        case FilingTypeEnum.OSSNONUNION:
        case FilingTypeEnum.OSSUNION:
            return true;
        case FilingTypeEnum.VATRETURN:
            return featureFlags?.[FeatureFlagEnum.ENABLE_VAT_RETURN_CORRECTION_ERRORS_WARNINGS] || 
                featureFlags?.[FeatureFlagEnum.ENABLE_VAT_RETURN_NON_CORRECTION_VIEW_ERRORS_WARNINGS];
        case FilingTypeEnum.VATBOOKS:
            return featureFlags?.[FeatureFlagEnum.ENABLE_VAT_BOOK_CORRECTION_ERRORS_WARNINGS];
        case FilingTypeEnum.ECLISTING:
            return featureFlags?.[FeatureFlagEnum.ENABLE_EC_LISTING_CORRECTION_ERRORS_WARNINGS];
        default:
            return false;
    }
};

export const checkFeatureFlagForReturnType = returnType => {
    const result = reportTypeMapping();
    return result[returnType];
};

export const getOssReturnTypes = () => {
    return [FilingTypeEnum.OSSIMPORT, FilingTypeEnum.OSSNONUNION, FilingTypeEnum.OSSUNION ];
}

export const getNonCorrectiveTypes = () => {
    return [FilingTypeEnum.VATRETURN];
}
